<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    default: true,
  },
  message: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <q-icon
    v-if="props.visible"
    name="mdi-information"
    color="primary"
    size="xs"
    style="margin-left: .25rem; cursor: default"
    @contextmenu.prevent
  >
    <q-tooltip
      anchor="top middle"
      self="bottom middle"
      :delay="300"
    >
      {{ props.message }}
    </q-tooltip>
  </q-icon>
</template>
